module.exports = __webpack_public_path__ + "static-portal/img/024.2dc7684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/024.jpg
// module id = 3Vy3
// module chunks = 4